import * as z from "zod/v4";

export const deleteReviewForm = {
  name: "deleteReviewForm" as const,
  input: z.object({ formId: z.string() }),
  output: z.null(),
};
